export class FooterMenu extends DrupalBehavior {
  handlersAdded = false;

  onContent(context) {
    let mql = window.matchMedia('(max-width: 767px)');
    let onWidthChanged = () => {
      if (this.handlersAdded) return;
      let quickPhone = document.querySelector('.footer--quick--phone ul');
      $('.footer--quick--phone .heading', context).on('click', function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
          gsap.to(quickPhone, {
            duration: 1,
            ease: 'power4.out',
            height: 'auto',
          });
        } else {
          gsap.to(quickPhone, { duration: 1, ease: 'power4.out', height: 0 });
        }
      });
      let quickLinks = document.querySelector('.footer--quick-links ul');
      $('.footer--quick-links .heading', context).on('click', function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
          gsap.to(quickLinks, {
            duration: 1,
            ease: 'power4.out',
            height: 'auto',
          });
        } else {
          gsap.to(quickLinks, { duration: 1, ease: 'power4.out', height: 0 });
        }
      });
      let employeePortal = document.querySelector('.footer--portals ul');
      $('.footer--portals .heading', context).on('click', function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
          gsap.to(employeePortal, {
            duration: 1,
            ease: 'power4.out',
            height: 'auto',
          });
        } else {
          gsap.to(employeePortal, {
            duration: 1,
            ease: 'power4.out',
            height: 0,
          });
        }
      });
      let ddlAccessibility = document.querySelector(
        '.dropdown--legal-links ul'
      );
      $('.dropdown--legal-links span', context).on('click', function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
          gsap.to(ddlAccessibility, {
            duration: 1,
            ease: 'power4.out',
            height: 'auto',
          });
        } else {
          gsap.to(ddlAccessibility, {
            duration: 1,
            ease: 'power4.out',
            height: 0,
          });
        }
      });
      this.handlersAdded = true;
    };

    let resetDesktop = () => {
      $('footer .footer--links ul').css('height', 'auto');
      $('.footer--quick--phone .heading').removeClass('open');
      $('.footer--portals .heading').removeClass('open');
      $('.dropdown--legal-links span').removeClass('open');
    };

    if (mql.matches) {
      onWidthChanged();
    }

    mql.addEventListener('change', (queryList, e) => {
      if (queryList.matches) {
        onWidthChanged();
      } else {
        resetDesktop();
      }
    });
  }
}
DrupalBehavior.register('rush_theme.components', 'footer', FooterMenu);
